import moment from "moment";
import { useState } from "react";
import { capitalize } from "lodash";
import Switch from "@mui/material/Switch";
import { Delete } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";

import { toggleModal } from "../../../../reducers/modalReducer";
import { BILLING, COMPANY } from "../../../../constants/routes";
import Certification from "../../../../components/Certification";
import { postRequest, showMessage } from "../../../../config.js";
import { setCompany } from "../../../../reducers/companyReducer.js";
import Button from "../../../../components/common/Button/index.jsx";
import { removeCompany } from "../../../../reducers/companiesReducer.js";
import ModalWrapper from "../../../../components/common/Modal/ModalWrapper.jsx";

import "react-circular-progressbar/dist/styles.css";


export default function Clients({ companies, setSelectedCompany, noClients, setPlan, handleHowItWorks, HOW_TO_POPUPS }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let user = useSelector((state) => state.user);

    let [viewEmail, setViewEmail] = useState({});
    let [benchmark, setBenchmark] = useState(true);
    let [eventsHistory, setEventsHistory] = useState({});
    let [deleteSelectedCompany, setDeleteSelectedCompany] = useState(null)

    const handleEventHistory = async (events) => {
        setEventsHistory(events);
        dispatch(toggleModal({ open: "advisorEventsHistory" }));
    };

    const hanleViewEmail = async (email, attachments) => {
        let updated = email
        attachments.map((attachment) => {
            updated = updated.replaceAll(
                `cid:${attachment.cid}`,
                attachment.href
            );
        })
        setViewEmail(updated);
        dispatch(toggleModal({ open: "viewEventEmail" }));
    };

    const handleRemoveFromDashboard = async () => {
        try {
            const response = await postRequest(`/company/remove-dashboard-company`, { companyId: deleteSelectedCompany['_id'] })
            if (response?.['code'] === 200) {
                dispatch(removeCompany({ _id: deleteSelectedCompany['_id'] }))
                dispatch(toggleModal({ open: '' }))
                return showMessage(response?.['message'])
            }
        } catch (e) {
            console.log(e)
        }
    };

    const handlePaymentPopup = async (paymentPlan) => {
        setPlan(paymentPlan);
        dispatch(toggleModal({ open: 'subscriptionPayment' }));
    };

    const showCompanyDetails = (company) => {

        const handleInviteResend = async () => {
            const response = await postRequest(`/company/resend-access-invite/${company['_id']}`, {});
        }

        let completeness, risk;
        if (benchmark) {
            risk = company?.["myBenchmark"]?.["risk"];
            completeness = company?.["myBenchmark"]?.["completeness"];
        } else {
            risk = company?.["overallBenchmark"]?.["risk"];
            completeness = company?.["overallBenchmark"]?.["completeness"];
        }
        let ristPrecentage = risk + 100 / 2;
        let completenessPrecentage = completeness + 100 / 2;

        let permissionAccess = "";
        if (user["role"] == "Advisor") {
            permissionAccess = company?.["advisors"]?.[user["_id"]]?.["type"];
            // If no direct access, check if any team member has access (for admin viewing team member's companies)
            if (!permissionAccess && company?.["advisorsData"]) {
                const teamMemberAdvisor = company["advisorsData"].find(advisor => advisor?.["createdBy"]?.toString() === user["_id"] || advisor?.["_id"] === user["_id"]);
                if (teamMemberAdvisor) permissionAccess = company?.["advisors"]?.[teamMemberAdvisor["_id"]]?.["type"] || 'ALL';
            }
        } else {
            permissionAccess = company?.["investors"]?.[user["_id"]]?.["type"];
            // If no direct access, check if any team member has access (for admin viewing team member's companies)
            if (!permissionAccess && company?.["investorData"]) {
                const teamMemberInvestor = company["investorData"].find(investor => investor?.["createdBy"]?.toString() === user["_id"] || investor?.["_id"] === user["_id"]);
                if (teamMemberInvestor) permissionAccess = company?.["investors"]?.[teamMemberInvestor["_id"]]?.["type"] || 'ALL';
            }
        }

        return (
            <>
                <div className='df clientNameSection' style={{ width: '270px' }}>

                    <div className="df fdc jcfs tal w100">
                        <h4 className="fs1-25rem c15 mb1rem w100">{company["cName"]}</h4>
                        <div className="df jcfs aife">
                            <span className="">
                                {company["subscription"] ? (
                                    <h2 className="fs1-25rem c7 mra tal">
                                        {company["subscription"] == "Pro" ? ("PRO") : (<>{company["subscription"]?.toUpperCase()}</>)}
                                    </h2>
                                ) : (<h2 className="fs1rem c8 mra tal">INACTIVE</h2>)}
                            </span>
                            <Link data-tooltip={"Company Settings"} to={`/company/${company['_id']}#company-settings`} className={`tac dashboard-btn c1 bg-gradient2 bg-gradient-hover br20px px0-25rem py0-5rem fs0-75rem fw500 mr0-5rem w100px td250 ml0-5rem ${(!company["subscription"]) && "pen"}`}>
                                Settings
                            </Link>

                            {permissionAccess && permissionAccess == "ALL" &&
                                <>
                                    {company['servicedBy'] && company['servicedBy'] === user['_id'] ? <div
                                        onClick={() => {
                                            dispatch(toggleModal({ open: 'removeCompanyFromDashboard' }))
                                            setDeleteSelectedCompany(company)
                                        }}
                                        className={`tac dashboard-btn c1 bg4 br20px px0-25rem py0-5rem fs0-75rem fw500 mr0-5rem w100px td250 ml0rem cp ${(!company["subscription"]) && "pen"}`}
                                    >
                                        Delete
                                    </div> : null
                                    }

                                </>
                            }
                        </div>
                    </div>
                </div>
                <div className="df aifs w250px jcc">
                    {user?.['companyId']?.['creatorId'] && (
                        <div className="df jcse w60px mr1rem">
                            <span className="w20 df jcc username-area tac">
                                <div className="df fdc aic">
                                    {user?.['companyId']?.['creatorId']?.["profile"] ? (
                                        <img className={`w40px h40px df jcc aic br100 cp mr0-5rem`} src={user?.['companyId']?.['creatorId']?.["profile"]}
                                            data-tooltip={user?.['companyId']?.['creatorId']?.["firstName"] ? user?.['companyId']?.['creatorId']?.["firstName"] + " " + (user?.['companyId']?.['creatorId']?.lastName ? user?.['companyId']?.['creatorId']?.lastName : "") : "Register to show your name here"} />
                                    ) : (
                                        <span data-tooltip={user?.['companyId']?.['creatorId']?.["firstName"] ? user?.['companyId']?.['creatorId']?.["firstName"] + " " + (user?.['companyId']?.['creatorId']?.lastName ? user?.['companyId']?.['creatorId']?.lastName : "") : "Register to show your name here"}
                                            className={`w40px h40px df jcc aic br100 bg3 c1 bw3px bss bo3`}>
                                            <>{user?.['companyId']?.['creatorId']?.["firstName"] ? user?.['companyId']?.['creatorId']?.["firstName"][0] : '?'}{user?.['companyId']?.['creatorId']?.["lastName"] ? user?.['companyId']?.['creatorId']?.["lastName"][0] : ""}</>
                                        </span>
                                    )}
                                    <span className="ass mt0-5rem fs0-75rem c15">{user['role']} <br />Admin</span>
                                </div>
                            </span>
                        </div>
                    )}
                    {company?.["creatorId"]?.["firstName"] && (
                        <div className="df jcse w60px mr1rem">
                            <span className="w20 df jcc username-area tac">
                                <div className="df fdc aic">
                                    {company?.["creatorId"] && (<>
                                        {company?.["creatorId"]["profile"] ? (
                                            <img src={company?.["creatorId"]["profile"]} className={`w40px h40px df jcc aic br100 cp mr0-5rem client-profile`}
                                                data-tooltip={(company?.['creatorId']?.['firstName'] && company['creatorId']['firstName']) + " " + (company?.['creatorId']?.['lastName'] ? company['creatorId']?.['lastName'] : "")} />
                                        ) : (
                                            <span data-tooltip={(company?.['creatorId']?.['firstName'] && company['creatorId']['firstName']) + " " + (company?.['creatorId']?.['lastName'] ? company['creatorId']?.['lastName'] : "")}
                                                className={`w40px h40px df jcc aic br100 c1 bw3px bss bo29 client-profile`}>
                                                <>{company?.['creatorId']?.['firstName'] && company['creatorId']['firstName'][0]}{company['creatorId']?.['lastName']?.[0] ? company['creatorId']['lastName'][0] : ""}</>
                                            </span>
                                        )}
                                        <span className="ass mt0-5rem fs0-75rem c15">Company <br />Admin</span>
                                    </>
                                    )}
                                </div>
                            </span>
                        </div>
                    )}
                    {
                        (company?.['group'] && company['group'] !== "Standard") && company['group'][0] ? <div className="df jcse w60px mr2rem">
                            <span className='w20 df username-area type-user mr2rem'>
                                <div className="df fdc">
                                    <span data-tooltip={(company?.['group'] && company['group'] !== "Standard") ? company['group'] : 'No group'} className={`w40px h40px df jcc aic br100 bg4 c1 bo4 bss bw3px mb1rem ${company['group'] ? 'fs1rem' : 'fs0-75rem'}`}>
                                        {(company?.['group'] && company['group'] !== "Standard") ? company['group'][0] : 'N/A'}
                                    </span>
                                    <span className="ass mt0-5rem fs0-75rem c15">Group</span>
                                </div>
                            </span>
                        </div> : null
                    }

                </div>
                <div className="df jcse aic fdc reprot-btn-dropdowns">
                    {/* Status Badge */}
                    {permissionAccess ? (
                        company?.["progress"] == "inActive" ? (
                            // Client login activated but awaiting client approval
                            <Link onClick={() => company["events"] && handleEventHistory(company["events"])}
                                data-tooltip="Awaiting client approval"
                                className={`c3 bo3 w100 tac br20px fs0-75rem py0-5rem fw500 dashboard-btn td250 mb0-5rem`}
                                style={{ border: "1px solid" }}>
                                Awaiting Client Approval
                            </Link>
                        ) : (
                            // Client has approved
                            <Link onClick={() => company["events"] && handleEventHistory(company["events"])}
                                data-tooltip={`${capitalize(permissionAccess)} access`}
                                className={`c3 bo3 w100 tac br20px fs0-75rem py0-5rem fw500 dashboard-btn td250 mb0-5rem`}
                                style={{ border: "1px solid" }}>
                                {`${capitalize(permissionAccess)} access`}
                            </Link>
                        )
                    ) : (
                        <button style={{ border: "1px solid" }} className={`pen c13 bo13 w100 tac br20px fs0-75rem py0-5rem fw500 w100 mb0-5rem dashboard-btn`}>
                            Awaiting Access
                        </button>
                    )}
                    {/* Dashboard Button */}
                    <Link
                        onClick={() => {
                            if (!permissionAccess) {
                                return showMessage("Company access not yet authorised");
                            } else if (!company["subscription"]) {
                                return showMessage("Please upgrade this company to a subscription");
                            } else {
                                dispatch(setCompany({}));
                            }
                        }}
                        data-tooltip={!permissionAccess ? "Company access not yet authorised" : ""}
                        to={(!permissionAccess || !company["subscription"]) ? "#" : COMPANY.replace(":id", company["_id"])}
                        className={`tac dashboard-btn c1 bg-gradient2 br20px px0-25rem py0-5rem fs0-75rem fw500 mr0-5rem w100 td250 ${!permissionAccess ? 'disabled-look' : ''}`}>
                        Dashboard
                    </Link>
                </div>
                <div className="progress-area progress-dashboard mx1rem" style={{ display: "flex", position: "relative", justifyContent: "center", }}>
                    <div className="progress-box df fdc aic">
                        <div className="progress-bar" style={{ width: 80, height: 80 }}>
                            <CircularProgressbar
                                className={`${company.stats.completionPercent > 67 ? "green"
                                    : company.stats.completionPercent > 33 ? "orange"
                                        : "red"
                                    }`}
                                strokeWidth={18}
                                value={company.stats.completionPercent || 0}
                                text={(company.stats.completionPercent || 0) + "%"}
                                styles={buildStyles({
                                    strokeLinecap: "round",
                                    strokeWidth: 35,
                                    textSize: "20px",
                                    pathTransitionDuration: 0.5,
                                    trailColor: "#d6d6d6",
                                    backgroundColor: "#fc7785",
                                    dominantBaseline: "ideographic",
                                })}
                            />
                        </div>
                        <div className="bottom-text df fdc tac jcc mt0-5rem">
                            <span className="fs1rem fw300 c15">
                                Overall
                            </span>
                            <span style={{ marginBottom: "0", }} className="text-center-area c15 fs1rem fw400">
                                Completeness
                            </span>
                        </div>
                    </div>
                    <div className="progress-box mx1rem df fdc aic">
                        <div className="progress-bar" style={{ width: 80, height: 80 }}>
                            <CircularProgressbar
                                className={`${company.stats.riskPercent > 67 ? "red"
                                    : company.stats.riskPercent > 33 ? "orange"
                                        : "green"
                                    }`}
                                strokeWidth={18}
                                value={company.stats.riskPercent || 0}
                                text={
                                    company.stats.completionPercent
                                        ? `${company.stats.riskPercent || 0}%`
                                        : "0%"
                                }
                                styles={buildStyles({
                                    strokeLinecap: "butt",
                                    strokeWidth: 35,
                                    textSize: "20px",
                                    pathTransitionDuration: 0.5,
                                    trailColor: "#d6d6d6",
                                    backgroundColor: "#fc7785",
                                    dominantBaseline: "ideographic",
                                })}
                            />
                        </div>
                        <div className="bottom-text df fdc tac jcc mt0-5rem">
                            <span className="fs1rem fw300 c15">
                                Overall
                            </span>
                            <span style={{ marginBottom: "0", }} className="text-center-area c15 fs1rem fw400">
                                Risk
                            </span>
                        </div>
                    </div>
                    <div className="progress-box df fdc aic">
                        <div
                            className={`cp progress-bar workflow-report-progress ${company?.stats?.workflowCompletionPercent > 75 ? 'workflow-progress-green' : company?.stats?.workflowCompletionPercent > 26 ? 'workflow-progress-yellow' : ' workflow-progress-pink'}`}
                            style={{ width: 80, height: 80, borderRadius: '50%', margin: 0, border: '2px solid #F1F1F1' }}>
                            <CircularProgressbar
                                text={(company?.stats?.workflowCompletionPercent || 0) + "%"}
                                styles={buildStyles({
                                    strokeWidth: '0',
                                    textSize: '20px',
                                    trailColor: '#FBFBFB',
                                    stroke: 'transparent',
                                    strokeLinecap: 'butt',
                                    backgroundColor: '#FBFBFB',
                                    pathTransitionDuration: 0.5,
                                    dominantBaseline: 'ideographic',
                                })}
                            />
                        </div>
                        <div className="bottom-text df fdc tac jcc mt0-5rem">
                            <span className="fs1rem fw300 c15">
                                Overall
                            </span>
                            <span style={{ marginBottom: "0", }} className="text-center-area c15 fs1rem fw400">
                                Workflow Completeness
                            </span>
                        </div>
                    </div>
                </div>
                <div className="df jcc fdc progress-box-vertical-dashboard" style={{ width: '162px' }}>
                    <div className="progress-box-vertical mt2rem">
                        <div className="df jcsb">
                            <span className="fs0-5rem c15">Low</span>
                            <span className="fs0-5rem c15">High</span>
                        </div>
                        <div className="progress progress-bar-vertical style-two">
                            <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{ width: `${completenessPrecentage}%` }}>
                                <span className="precentage-block">
                                    <i className="icon"><img src={require('../../../../../images/precentage-icon.png')} alt="" /></i>
                                    <span className="fs0-75rem mb0-5rem arrow-right">
                                        {completenessPrecentage < 35 ? "Below Average" : completenessPrecentage > 70 ? "Above Average" : "Average"}
                                    </span>
                                </span>
                            </div>
                        </div>
                        <span style={{ marginBottom: "0", fontSize: "12px" }} className="text-center-area c15">
                            Completeness
                        </span>
                    </div>
                    <div className="progress-box-vertical style-two mt2rem">
                        <div className="df jcsb">
                            <span className="fs0-5rem c15">Low</span>
                            <span className="fs0-5rem c15">High</span>
                        </div>
                        <div className="progress progress-bar-vertical">
                            <div role="progressbar" style={{ width: `${ristPrecentage}%` }} className="progress-bar progress-bar-striped progress-bar-animated">
                                <span className="precentage-block">
                                    <i className="icon"><img src={require('../../../../../images/precentage-icon.png')} alt="" /></i>
                                    <span className="fs0-75rem mb0-5rem arrow-right">
                                        {ristPrecentage < 35 ? "Below Average" : ristPrecentage > 70 ? "Above Average" : "Average"}
                                    </span>
                                </span>
                            </div>
                        </div>
                        <span style={{ marginBottom: "0", fontSize: "12px" }} className="text-center-area c15">
                            Risk
                        </span>
                    </div>
                </div>
                <div className="df jcse mt0-5rem mx1rem">
                    <div className="certificate-area-dashboard">
                        {company["cLevel"] && (company["subscription"] == "Pro" || company["subscription"] == "Pro Plus") && (<>
                            <Link data-tooltip="Certification" to={permissionAccess == "ALL" && `/company/${company['_id']}#unaudited-certification`} className="cp">
                                <Certification className={"op70"} component='Clients' level={company["subscription"] == "Lite" ? "None" : company["cLevel"]}
                                    expiryTimestamp={company["createdAt"]} company={company} subscription={company["subscription"]} />
                            </Link>
                        </>
                        )}
                    </div>
                    {!permissionAccess && (user['role'] == 'Advisor' || user['role'] == 'Investor') && <button className="cp bg1" onClick={handleInviteResend} title="Resend invitation">
                        <i data-tooltip="Resend invitation" className="fa fa-repeat c7" style={{ fontSize: "20px" }} />
                    </button>
                    }

                </div>
            </>
        );
    };

    return (
        <>
            <div className="df jcsb py1rem add-client-area">
                <div className="df">
                    <div className="pr">
                        <div onClick={() => dispatch(toggleModal({ open: "addCompany" }))} className="df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard">
                            <span className='bg1 bsbb mr0-5rem br100 w40px h40px tac df jcc aic'>
                                <svg className='h30px w30px' width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_2656_879)">
                                        <path d="M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z" fill="#4A67FF" />
                                        <path d="M27.3098 20.5825H20.5805V27.3118C20.5805 28.1859 19.8714 28.895 18.9973 28.895C18.1232 28.895 17.4141 28.1859 17.4141 27.3118V20.5825H10.6848C9.8107 20.5825 9.10156 19.8734 9.10156 18.9993C9.10156 18.1252 9.8107 17.416 10.6848 17.416H17.4141V10.6868C17.4141 9.81265 18.1232 9.10352 18.9973 9.10352C19.8714 9.10352 20.5805 9.81265 20.5805 10.6868V17.416H27.3098C28.1839 17.416 28.893 18.1252 28.893 18.9993C28.893 19.8734 28.1839 20.5825 27.3098 20.5825Z" fill="#FAFAFA" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_2656_879">
                                            <rect width="38" height="38" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                            <span className='c15 pr'>
                                Add {user['role'] == 'Investor' ? ' Portfolio Company' : ' Client'}
                            </span>
                        </div>
                        {user['role'] == 'Advisor' &&
                            <div className='right-info-hyper-icon'>
                                <div className='hover-list-icon pr cp' onClick={() => handleHowItWorks(HOW_TO_POPUPS['add-client'])}>
                                    <svg width="18" height="18" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="13.5" cy="13.5" r="13.5" fill="#59B8FD" />
                                        <path d="M12.5822 17.454C12.314 17.454 12.0971 17.2371 12.0971 16.9689C12.0971 16.3344 12.1871 15.7863 12.3662 15.3255C12.4976 14.9781 12.7109 14.628 13.0043 14.2743C13.2203 14.0169 13.6073 13.6407 14.1671 13.1475C14.7269 12.6534 15.0905 12.2601 15.2588 11.9667C15.4271 11.6733 15.5099 11.3529 15.5099 11.0055C15.5099 10.3764 15.2642 9.82469 14.7737 9.34859C14.2832 8.87249 13.6811 8.63489 12.9683 8.63489C12.2798 8.63489 11.7047 8.85089 11.2439 9.28199C10.9073 9.59699 10.6544 10.0416 10.487 10.6158C10.3718 11.01 9.9875 11.262 9.5798 11.2134C9.0632 11.1522 8.723 10.641 8.8706 10.1415C9.0974 9.37379 9.4772 8.75549 10.0091 8.28569C10.748 7.63139 11.7254 7.30469 12.9413 7.30469C14.2283 7.30469 15.2552 7.65479 16.022 8.35589C16.7888 9.05699 17.1713 9.90389 17.1713 10.8975C17.1713 11.4726 17.0363 12.0027 16.7672 12.4869C16.4981 12.972 15.9707 13.5615 15.1868 14.2563C14.6603 14.7234 14.3156 15.0681 14.1536 15.2895C13.9916 15.5109 13.8719 15.7656 13.7945 16.0527C13.7369 16.266 13.6973 16.5792 13.6757 16.9905C13.6622 17.2497 13.4471 17.4531 13.1879 17.4531H12.5822V17.454ZM12.0071 19.776C12.0071 19.2675 12.4193 18.8553 12.9278 18.8553C13.4363 18.8553 13.8485 19.2675 13.8485 19.776C13.8485 20.2845 13.4363 20.6967 12.9278 20.6967C12.4193 20.6967 12.0071 20.2845 12.0071 19.776Z" fill="white" />
                                    </svg>
                                    <div className='overlay-box'>
                                        <p className='c15 df aic'>
                                            How does it work?
                                            <i className='icon'>
                                                <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z" fill="#505050" />
                                                </svg>
                                            </i>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <div onClick={() => dispatch(toggleModal({ open: 'groupCompanies' }))} className={`${companies && companies.length <= 1 && 'op20 pen '} df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard`}>
                        <span className='bg1 bsbb mr0-5rem br100 w40px h40px tac df jcc aic'>
                            <svg className='h30px w30px' width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_2656_879)">
                                    <path d="M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z" fill="#4A67FF" />
                                    <path d="M27.3098 20.5825H20.5805V27.3118C20.5805 28.1859 19.8714 28.895 18.9973 28.895C18.1232 28.895 17.4141 28.1859 17.4141 27.3118V20.5825H10.6848C9.8107 20.5825 9.10156 19.8734 9.10156 18.9993C9.10156 18.1252 9.8107 17.416 10.6848 17.416H17.4141V10.6868C17.4141 9.81265 18.1232 9.10352 18.9973 9.10352C19.8714 9.10352 20.5805 9.81265 20.5805 10.6868V17.416H27.3098C28.1839 17.416 28.893 18.1252 28.893 18.9993C28.893 19.8734 28.1839 20.5825 27.3098 20.5825Z" fill="#FAFAFA" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_2656_879">
                                        <rect width="38" height="38" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </span>
                        <span className='c15'>Create Group</span>
                    </div>
                </div>
                {companies && companies.length > 0 && (
                    <div className="df bg1 br50px mr0-5rem bw2px bss pr1rem p0-5rem pl1rem bsbb aic mr1rem cp add-btn-dashboard add-btn-dashboard-switch pr">
                        <label className="fs0-75rem fw600">
                            {benchmark
                                ? `${user["role"] == "Investor" ? "Investor" : "Client"} Portfolio Benchmark`
                                : "Overall Benchmark"}
                        </label>
                        <Switch className="dashboard-benchmark-switch" defaultChecked={benchmark} onChange={(e) => setBenchmark(e.target.checked)} />
                        <div className='right-info-hyper-icon' style={{ top: '-8px', right: '2px' }}>
                            <div className='hover-list-icon  pr cp ml0-5rem' onClick={() => handleHowItWorks(HOW_TO_POPUPS['client-benchmarking'])}>
                                <svg width="18" height="18" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="13.5" cy="13.5" r="13.5" fill="#59B8FD" />
                                    <path d="M12.5822 17.454C12.314 17.454 12.0971 17.2371 12.0971 16.9689C12.0971 16.3344 12.1871 15.7863 12.3662 15.3255C12.4976 14.9781 12.7109 14.628 13.0043 14.2743C13.2203 14.0169 13.6073 13.6407 14.1671 13.1475C14.7269 12.6534 15.0905 12.2601 15.2588 11.9667C15.4271 11.6733 15.5099 11.3529 15.5099 11.0055C15.5099 10.3764 15.2642 9.82469 14.7737 9.34859C14.2832 8.87249 13.6811 8.63489 12.9683 8.63489C12.2798 8.63489 11.7047 8.85089 11.2439 9.28199C10.9073 9.59699 10.6544 10.0416 10.487 10.6158C10.3718 11.01 9.9875 11.262 9.5798 11.2134C9.0632 11.1522 8.723 10.641 8.8706 10.1415C9.0974 9.37379 9.4772 8.75549 10.0091 8.28569C10.748 7.63139 11.7254 7.30469 12.9413 7.30469C14.2283 7.30469 15.2552 7.65479 16.022 8.35589C16.7888 9.05699 17.1713 9.90389 17.1713 10.8975C17.1713 11.4726 17.0363 12.0027 16.7672 12.4869C16.4981 12.972 15.9707 13.5615 15.1868 14.2563C14.6603 14.7234 14.3156 15.0681 14.1536 15.2895C13.9916 15.5109 13.8719 15.7656 13.7945 16.0527C13.7369 16.266 13.6973 16.5792 13.6757 16.9905C13.6622 17.2497 13.4471 17.4531 13.1879 17.4531H12.5822V17.454ZM12.0071 19.776C12.0071 19.2675 12.4193 18.8553 12.9278 18.8553C13.4363 18.8553 13.8485 19.2675 13.8485 19.776C13.8485 20.2845 13.4363 20.6967 12.9278 20.6967C12.4193 20.6967 12.0071 20.2845 12.0071 19.776Z" fill="white" />
                                </svg>
                                <div className='overlay-box'>
                                    <p className='c15 df aic'>
                                        How does it work?
                                        <i className='icon'>
                                            <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.1659 7.57457V10.6723C11.1659 12.3866 9.77122 13.7812 8.05696 13.7812H6.37657C5.23568 13.7812 4.25418 13.2147 3.68373 12.2268L1.77282 8.91715C1.58918 8.5978 1.69863 8.18893 2.01661 8.00543C2.73387 7.59183 3.61212 7.81624 4.0161 8.51635L4.50071 9.35517V4.7025C4.50071 4.15516 4.94565 3.70986 5.49252 3.70986C6.0394 3.70986 6.48516 4.15516 6.48516 4.7025V6.49204C6.65337 6.36068 6.86477 6.28236 7.09416 6.28236C7.42275 6.28236 7.71453 6.44282 7.8953 6.68954C8.07593 6.44282 8.36747 6.28236 8.69579 6.28236C9.10548 6.28236 9.45802 6.53185 9.6094 6.88688C9.7748 6.7358 9.9947 6.6436 10.2357 6.6436C10.7486 6.6436 11.1659 7.06125 11.1659 7.57457ZM5.90232 2.44038V0.628906C5.90232 0.402391 5.71868 0.21875 5.49217 0.21875C5.26565 0.21875 5.08201 0.402391 5.08201 0.628906V2.44035C5.08201 2.66686 5.26565 2.8505 5.49217 2.8505C5.71868 2.8505 5.90232 2.66689 5.90232 2.44038ZM3.46769 4.87501C3.46769 4.64849 3.28405 4.46485 3.05753 4.46485H1.24609C1.01958 4.46485 0.835938 4.64849 0.835938 4.87501C0.835938 5.10152 1.01958 5.28516 1.24609 5.28516H3.05753C3.28405 5.28516 3.46769 5.10152 3.46769 4.87501ZM10.1492 4.87501C10.1492 4.64849 9.96558 4.46485 9.73906 4.46485H7.92759C7.70108 4.46485 7.51744 4.64849 7.51744 4.87501C7.51744 5.10152 7.70108 5.28516 7.92759 5.28516H9.73906C9.96558 5.28516 10.1492 5.10152 10.1492 4.87501ZM4.23261 3.61648C4.39287 3.45639 4.39298 3.19668 4.23288 3.03641L3.45079 2.25354C3.2907 2.0933 3.03098 2.09316 2.87072 2.25326C2.71046 2.41336 2.71035 2.67307 2.87045 2.83333L3.65254 3.61621C3.73265 3.69638 3.83765 3.7365 3.94271 3.7365C4.04776 3.7365 4.15254 3.69646 4.23261 3.61648ZM7.3318 3.61621L8.11389 2.83333C8.27398 2.67307 8.27385 2.41336 8.11361 2.25326C7.95335 2.09314 7.69364 2.0933 7.53354 2.25354L6.75146 3.03641C6.59136 3.19668 6.5915 3.45639 6.75173 3.61648C6.83182 3.69649 6.93671 3.73647 7.04163 3.73647C7.14655 3.73647 7.25171 3.69641 7.3318 3.61621Z" fill="#505050" />
                                            </svg>
                                        </i>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {companies && companies.length > 0
                ? companies.map((company, idx) => {
                    return (
                        <div key={idx} className="dropdown-company-dahboard">
                            <div className="dg gtcr6-md gg1rem py0-5rem px2rem br20px aic bg29 fs1rem mb2rem company-dashboard-sf clientCard" style={{ border: '1px solid #7385BE50', backgroundColor: '#F0F2FD50' }}>
                                {showCompanyDetails(company)}
                            </div>
                            {company['childrenCompanies'] && company['childrenCompanies'].length > 0 && <>
                                <div className="dropdown-content">
                                    {company['childrenCompanies'] && company['childrenCompanies'].map((childrenCompany, idx) => {
                                        return (
                                            <div key={idx} className="dg gtcr6-md gg1rem py0-5rem px1rem br20px aic bg29 fs1rem mb1rem company-dashboard-sf" style={{ border: '1px solid #7385BE50', backgroundColor: '#F0F2FD50' }}>
                                                {showCompanyDetails(childrenCompany)}
                                            </div>
                                        )
                                    })}
                                </div>
                            </>}
                        </div>
                    );
                })
                : <>
                    {noClients && <h1 className='tac c15 fs1-75rem pt1rem pb3rem lh2 fw500'>
                        {user['role'] == 'Investor'
                            ? 'No Portfolio Company Added'
                            : 'No Clients Added'
                        }
                    </h1>}
                </>
            }

            {/* Advisor Events History */}
            <ModalWrapper modalType={'advisorEventsHistory'} modalCardClasses="mawmc">
                <div>
                    <h1 className="c15 fs1-5rem fw600 tac ttu mb1rem">Advisor Events History</h1>
                    <table id="table" className="table-activation-advisor">
                        <thead className="ps t0">
                            <tr>
                                <th className="fs1-25rem c15">Subject</th>
                                <th className="fs1-25rem c15">Sent By</th>
                                <th className="fs1-25rem c15">Sent To</th>
                                <th className="fs1-25rem c15">Date</th>
                                <th className="fs1-25rem c15">Email</th>
                            </tr>
                        </thead>
                        <tbody>
                            {eventsHistory &&
                                Object.keys(eventsHistory).sort().map((event) => {
                                    return (
                                        <tr>
                                            <td className="c6 fs1rem">{eventsHistory[event]["subject"] || eventsHistory[event]["type"]}</td>
                                            <td className="c11 fs1rem"><p>{eventsHistory[event]["from"] ? eventsHistory[event]["from"] : "-"}</p></td>
                                            <td className="c11 fs1rem"><p>{eventsHistory[event]["email"] ? eventsHistory[event]["email"] : "-"}</p></td>
                                            <td className="c6 fs1rem">
                                                {" "}
                                                {event ? moment(Number(event)).format("lll") : "-"}
                                            </td>
                                            <td className="df jcc w100">
                                                {eventsHistory[event]["html"] && (
                                                    <span onClick={() => hanleViewEmail(eventsHistory[event]["html"], eventsHistory[event]["attachments"])} className="shadow bg3 bg4-hover c1 td250 br5px py0-5rem px1rem fw600 usn cp ttu my0-5rem fs0-75rem">
                                                        View Email
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </table>
                </div>
            </ModalWrapper>

            {/* View Email */}
            <ModalWrapper modalType={'viewEventEmail'} modalCardClasses="mawmc" onCloseHandler={() => handleEventHistory(eventsHistory)}>
                <div>{viewEmail && (<span dangerouslySetInnerHTML={{ __html: viewEmail }}></span>)}</div>
            </ModalWrapper>

            {/* Remove company from dashboard */}
            <ModalWrapper modalType={'removeCompanyFromDashboard'}>
                <div className="row fdc tac">
                    <Delete sx={{ fontSize: '8rem', margin: '20px auto', color: "#FC7785" }} />
                    <span className="c15 fs14px">Are you sure to remove <b>{deleteSelectedCompany?.['cName']}</b> from your dashboard?</span>
                </div>
                <div className="df aic jcc mt2rem">
                    <Button text={"Cancel"} onClick={() => { dispatch(toggleModal({ open: '' })), setDeleteSelectedCompany(null) }} customClassName="c1 mr1rem" />
                    <Button text={"Delete"} btnType="warning" onClick={handleRemoveFromDashboard} />
                </div>
            </ModalWrapper>
        </>
    );
}